// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"c74a6d1a","149":"9fc182e7","172":"7dec964f","256":"8c129e26","342":"98777bc4","365":"cbf04e10","394":"9e34c999","912":"9de394e1"}[chunkId] + ".chunk.js";
};